import classnames from 'classnames'
import * as React from 'react'
import { compose, pure } from 'recompose'

import Icon, { IconColorType, IconType } from '../../atoms/Icon/Icon'

import * as styles from './RankingTitle.css'

interface RankingTitleProps {
  rank: number
}

const RankingTitle: React.FunctionComponent<RankingTitleProps> = ({ rank }) => {
  let rankType = IconColorType.WHITE
  switch (rank) {
    case 1:
      rankType = IconColorType.GOLD
      break

    case 2:
      rankType = IconColorType.SILVER
      break

    case 3:
      rankType = IconColorType.BRONZE
      break
  }
  return (
    <div className={styles.container}>
      <p className={styles.text}>第</p>
      <div className={styles.lRank}>
        <div className={classnames(styles.rank, styles[rankType])}>
          <p className={styles.number}>{rank}</p>
        </div>
        <div className={styles.crown}>
          <Icon iconType={IconType.CROWN} colorType={rankType} />
        </div>
      </div>
      <p className={styles.text}>位</p>
    </div>
  )
}

export default compose(pure)(RankingTitle)
